import { render, staticRenderFns } from "./PhotoCropper.vue?vue&type=template&id=ebf60496&scoped=true&"
import script from "./PhotoCropper.vue?vue&type=script&lang=js&"
export * from "./PhotoCropper.vue?vue&type=script&lang=js&"
import style0 from "./PhotoCropper.vue?vue&type=style&index=0&id=ebf60496&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebf60496",
  null
  
)

export default component.exports